import styled, { createGlobalStyle, css } from 'styled-components';
import { DatePicker, DatePickerProps } from 'antd';
import { pickThemeColor, pickThemeFontStyles } from '@/theme';

const getStylesBySize = (size?: DatePickerProps['size']) => {
  switch (size) {
    case 'small':
      return css`
        padding: 0.32rem;
      `;
    case 'middle':
      return css`
        padding: 0.6rem;
      `;
    case 'large':
    default:
      return css`
        padding: 0.75rem;
      `;
  }
};

export const GlobalStyles = createGlobalStyle`
  .ant-picker-borderless {
    background-color: ${pickThemeColor('WHITE')};
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid ${pickThemeColor('WHITE')};

    &:not(:disabled):hover,
    &:not(:disabled):focus-within {
      border-color: ${pickThemeColor('WHITE')};
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
    }

    &::placeholder {
      ${pickThemeFontStyles('16', '18')};
    }
  }
`;

export const StyledDatePicker = styled(DatePicker)<
  {
    $size?: DatePickerProps['size'];
  } & DatePickerProps
>`
  width: 100%;

  .ant-picker-suffix {
    color: transparent !important;
  }

  ${({ $size }) => getStylesBySize($size)}

  &.ant-picker-outlined:focus-within,
  &.ant-picker-outlined:focus,
  &.ant-picker-outlined:hover {
    box-shadow: 0 0 0 0.125rem rgb(254, 173, 21, 0.1);
  }
` as typeof DatePicker;
